import axios from "axios";
import router from "@/routes";

export default {
  strict: true,
  namespaced: true,
  state: {
    organization: null,
    organizations: [],
    cobrandRefreshKey: 0,
  },
  getters: {
    organization: (state) => state.organization,
    organizations: (state) => state.organizations,
    hasMultipleOrganizations: (state) => state.organizations && state.organizations.length > 1,
    isOrganizationPredictile: (state) => state.organization && state.organization.type === "predictile",
    isOrganizationBusiness: (state) => state.organization && state.organization.type === "business",
    isOrganizationUser: (state) => state.organization && state.organization.type === "user",
    // RxH dynamic role/permission matrix is enabled per-business (off everywhere by default).
    isRoleMatrixEnabled: (state) => !!state.organization && state.organization.useRoleMatrix === true,
    cobrandId(state) {
      if (state.organization) {
        switch (state.organization.id) {
          case "840b1480-1439-4aa4-9e4b-0fdba48add55":
          case "4c205bd3-d707-4d83-8f25-ba493e6eaa02":
          case "4c8fefbb-454b-40ac-b98f-31acb6a1fa5c":
            return "rx-harmony";
        }

        if (state.organization.description === "Rx Harmony") return "rx-harmony";
      }

      state.cobrandRefreshKey; // use to trigger refresh
      if (localStorage.cobrand) {
        return localStorage.cobrand;
      }

      return "";
    },
  },
  mutations: {
    setOrganization(state, payload) {
      state.organization = payload;
    },
    setOrganizations(state, payload) {
      state.organizations = payload;
    },
    activateOrganization(state) {
      state.organization.isActive = true;
    },
    setCobrand(state, cobrand) {
      localStorage.setItem("cobrand", cobrand);
      state.cobrandRefreshKey++;
    },
  },
  actions: {
    init: async (context) => {
      // is authenticated
      if (!context.rootGetters["cognito/isAuthenticated"]) {
        context.commit("setOrganization", null);
        sessionStorage.removeItem("organization/id");
        return;
      }

      // organizations
      try {
        const organizationsResponse = await axios.get("/organizations");
        context.commit("setOrganizations", organizationsResponse.data);
        if (!organizationsResponse.data || organizationsResponse.data.length === 0) {
          router.push("/login-error");
          return;
        }
      } catch (error) {
        if (error.response && error.response.data) {
          const errors = error.response.data;
          const errorList = Array.isArray(errors) ? errors : errors.errors;
          if (Array.isArray(errorList) && errorList.some((e) => e.message === "ACCOUNT_DELETED")) {
            router.push("/login-error");
            return;
          }
        }

        const hasStartedPinMode = sessionStorage.getItem("hasStartedPinMode") === "true";
        if (hasStartedPinMode) {
          router.push("/pin-mode");
        } else {
          router.push("/signout");
        }
        return;
      }

      // organization
      var organizationId = sessionStorage.getItem("organization/id");
      if (organizationId) {
        await axios
          .get(`/organizations/${organizationId}`)
          .then((res) => {
            context.commit("setOrganization", res.data);
            sessionStorage.setItem("organization/id", res.data.id);
          })
          .catch(() => {
            var organization = context.state.organizations.find((o) => o.type === "user");
            context.commit("setOrganization", organization);
            sessionStorage.setItem("organization/id", organization.id);
          });
      } else {
        var organization = {};

        if (context.state.organizations.find((o) => o.type === "predictile")) {
          organization = context.state.organizations.find((o) => o.type === "predictile");
          context.commit("setOrganization", organization);
          sessionStorage.setItem("organization/id", organization.id);
          return;
        } else if (context.state.organizations.find((o) => o.type === "business")) {
          organization = context.state.organizations.find((o) => o.type === "business");
          context.commit("setOrganization", organization);
          sessionStorage.setItem("organization/id", organization.id);
          return;
        } else {
          organization = context.state.organizations.find((o) => o.type === "user");
          context.commit("setOrganization", organization);
          if (organization) {
            sessionStorage.setItem("organization/id", organization.id);
          }
          return;
        }
      }
    },
    changeOrganization: async (context, organizationId) => {
      if (!organizationId) return;
      await axios
        .get(`/organizations/${organizationId}`)
        .then((res) => {
          context.commit("setOrganization", res.data);
          sessionStorage.setItem("organization/id", res.data.id);
        })
        .catch(() => {
          var organization = context.state.organizations.find((o) => o.type === "user");
          context.commit("setOrganization", organization);
          sessionStorage.setItem("organization/id", organization.id);
        });
    },
    clearOrganization: async (context) => {
      context.commit("setOrganization", null);
      context.commit("setOrganizations", null);
    },
    activateOrganization: async (context) => {
      context.commit("activateOrganization");
    },
  },
};
